import { render, staticRenderFns } from "./AlertPending.vue?vue&type=template&id=1fb326df"
import script from "./AlertPending.vue?vue&type=script&lang=js"
export * from "./AlertPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports